// extracted by mini-css-extract-plugin
module.exports = {"root":"EditableTitle__root___7vp98","editActions":"EditableTitle__editActions___2N-ni","hovered":"EditableTitle__hovered___YuRCH","edit":"EditableTitle__edit___2htuE"};